import type { AppThemeState } from './GlobalStateModel';

const GLOBAL_APP_THEME_KEY = 'globalAppTheme';

export const globalAppThemeLocalStorage = {
  set: (value: AppThemeState): void =>
    localStorage.setItem(GLOBAL_APP_THEME_KEY, value),
  get: (): AppThemeState =>
    (localStorage.getItem(GLOBAL_APP_THEME_KEY) || 'light') as AppThemeState,
};
